import {getAxios, getEndpointBase} from "./base.api";
import * as querystring from "../utils/querystring";

const ENDPOINT = "GetDoc";

const axios = getAxios();

export async function getDoc(urlId: string, name: string) {
    const apiUrl = getEndpointBase(ENDPOINT);

    const queryString = querystring.stringify({
        URLId: urlId,
    });

    try {
        const response = await axios.get(`${apiUrl}?${queryString}`, {
            responseType: 'arraybuffer'
        });

        if (response.status >= 200 && response.status < 300) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.style.visibility = 'hidden';
            link.href = url;
            link.setAttribute('download', `${name}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else {
            console.error('Error:', response.status, response.data);
            throw new Error(`Error: ${response.status}`);
        }
    } catch (error) {
        console.error(`API Endpoint error: ${error}`);
    }
}
